export enum ITEM_POSITION {
    LEFT = 'left',
    CENTER = 'center',
    RIGHT = 'right',
}

export const STYLE_CARD_3_COLUMNS_CLASS = 'style-card-3-columns';
export const STYLE_CARD_SUBTRACT_HEIGHT = 62 + 56 + 71 + 54 + 44 + 10; // header + footer + chat box + show now button & share/like/dislike + padding
export const DESKTOP_AMIRA_MESSAGE_WIDTH = 400;
